module.exports = __webpack_public_path__ + "img/green.dde97ac9.svg";